export { default } from "./useChallengeReportGet";
